import React from 'react';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import Hero from 'Global/Hero/Hero';
import TextContent from 'Component/TextContent/TextContent';
import CtaSection from 'Component/CtaSection/CtaSection';
import MultiColumnFeature from 'Component/MultiColumnFeature/MultiColumnFeature';

import IconsData from 'IconsData/CorporateTreasury.json';
import { WhyCT } from 'TextContentData/CorporateTreasury/WhyCT.js';
import { WhyMFCT } from 'TextContentData/CorporateTreasury/WhyMFCT.js';
import MultiColumnFeatureData from 'MultiColumnFeatureData/CorporateTreasury.json';

const CorporateTreasury = () => {
	return (
		<Layout>
			<SEO title="Corporate Treasury" description="" />
			<Hero
				heading="Corporate Treasury"
				iconsData={IconsData}
				ctaFormText="Interested in Moneyfront's Corporate Treasury service?"
				customClass="bgCorporateTreasury"
			/>
			<TextContent
				heading="Why Corporate Treasury?"
				data={WhyCT}
				customClass="whatDirectMF"
			/>
			<CtaSection heading="Want to understand how your business can benefit? Connect with us" />
			<MultiColumnFeature
				heading="Benefits of Corporate Treasury Management"
				data={MultiColumnFeatureData}
				customClass="corporateTreasury"
			/>
			<TextContent
				heading="Why Moneyfront as your Corporate Treasury Manager?"
				data={WhyMFCT}
				customClass="paraAlwaysLeft"
			/>
			<CtaSection
				heading="Call us for your corporate treasury requirements."
				subheading="We look forward to competently supporting you in managing your financial goals and in mitigating your risks."
				customClass="inFooter"
			/>
		</Layout>
	);
};

export default CorporateTreasury;
